import { StyleSheet } from "react-native";

export default StyleSheet.create({
  botao: {
    margin: 10,
    height: 42,
    backgroundColor: "#de1d13",
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  botaoText: {
    fontFamily: "Montserrat-BlackItalic",
    fontSize: 16,
    color: "#fff",
  },
});
